
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import store from './store';

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// router setup
import routes from "./routes/routes";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Api from "./plugins/api.js";
import Helper from './plugins/helper.js';
import Request from "./plugins/request";

import QrcodeVue from 'qrcode.vue'
import PrimeVue from 'primevue/config'
import {PrimeIcons} from 'primevue/api';


Vue.prototype.$store = store


import "./registerServiceWorker";
// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(VueAxios, axios);
Vue.use(Api);
Vue.use(Helper);
Vue.use(Antd);
Vue.use(Request);
Vue.use(QrcodeVue);
Vue.use(PrimeVue, {ripple: true});
Vue.use(PrimeIcons);


window._axios = axios;

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

const isLoggedIn = function() {
  // JWT token'ını localStorage veya Vuex'den kontrol edin
  return !!localStorage.getItem('access_token');
}
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/unauthorized') {
    next(); 
    return;
  }
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next({
        path: '/login'
      });
  } else {
    next(); 
  }
});



/* eslint-disable no-new */
const $app = new Vue({
  el: "#app",
  store,
  render: (h) => h(App),
  router,
});

window._app = $app


